/* Agua Rozzi · comportamiento de las secciones ZEEN.
   Se incluye desde varias secciones y el pie de página: el guard evita inicializar dos veces. */
(function () {
  if (window.__rozzi) return;
  window.__rozzi = true;

  var doc = document;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = !!(window.Shopify && window.Shopify.designMode);
  var canObserve = 'IntersectionObserver' in window && !reduce && !design;

  function reveal(root) {
    var els = root.querySelectorAll('.rz-reveal:not(.is-in)');
    if (!canObserve) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Frase: cada palabra se enciende al cruzar la línea de lectura, en orden. */
  function tagline(root) {
    root.querySelectorAll('[data-rz-tagline]').forEach(function (box) {
      var words = Array.prototype.slice.call(box.querySelectorAll('.rz-word'));
      if (!canObserve) {
        words.forEach(function (w) { w.classList.add('is-on'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        var batch = entries.filter(function (e) { return e.isIntersecting; })
          .map(function (e) { return e.target; })
          .sort(function (a, b) { return words.indexOf(a) - words.indexOf(b); });
        batch.forEach(function (w, i) {
          w.style.transitionDelay = (i * 70) + 'ms';
          w.classList.add('is-on');
          io.unobserve(w);
        });
      }, { rootMargin: '0px 0px -30% 0px', threshold: 1 });
      words.forEach(function (w) { io.observe(w); });
    });
  }

  function comuna(root) {
    root.querySelectorAll('[data-rz-comuna]').forEach(function (box) {
      var select = box.querySelector('select');
      if (!select || select.dataset.rzReady) return;
      select.dataset.rzReady = '1';

      function show() {
        var opt = select.options[select.selectedIndex];
        var estado = opt && opt.value ? (opt.dataset.estado || 'no') : '';
        box.querySelectorAll('[data-rz-res]').forEach(function (panel) {
          panel.hidden = panel.dataset.rzRes !== estado;
        });
        if (!estado) return;
        box.querySelectorAll('[data-rz-nombre]').forEach(function (n) { n.textContent = opt.textContent.trim(); });
        box.querySelectorAll('[data-rz-nota]').forEach(function (n) {
          n.textContent = opt.dataset.nota || '';
          n.hidden = !opt.dataset.nota;
        });
        box.querySelectorAll('[data-rz-url]').forEach(function (a) {
          if (opt.dataset.url) a.setAttribute('href', opt.dataset.url);
          a.hidden = !opt.dataset.url;
        });
      }

      select.addEventListener('change', function () {
        show();
        try { localStorage.setItem('rz_comuna', select.value); } catch (err) {}
      });

      try {
        var saved = localStorage.getItem('rz_comuna');
        if (saved && select.querySelector('option[value="' + saved.replace(/[^a-z0-9-]/g, '') + '"]')) {
          select.value = saved;
          show();
        }
      } catch (err) {}
    });
  }

  /* Selector de cantidad: un solo listener para toda la página. */
  function clamp(input, val) {
    var min = parseInt(input.min, 10) || 1;
    var max = parseInt(input.max, 10) || 99;
    if (isNaN(val)) val = min;
    return Math.min(max, Math.max(min, val));
  }
  doc.addEventListener('click', function (ev) {
    var btn = ev.target.closest && ev.target.closest('[data-rz-qty]');
    if (!btn) return;
    var input = btn.closest('.rz-qty').querySelector('input');
    input.value = clamp(input, (parseInt(input.value, 10) || 0) + parseInt(btn.dataset.rzQty, 10));
  });
  doc.addEventListener('change', function (ev) {
    var input = ev.target;
    if (!input.matches || !input.matches('.rz-qty input')) return;
    input.value = clamp(input, parseInt(input.value, 10));
  });

  /* El formulario de compra de un bloque: el del pedido rápido lo contiene;
     en la ficha el bloque está al lado, así que se busca en la misma sección. */
  function formFor(el) {
    var f = el.closest('form');
    if (f) return f;
    var sec = el.closest('.shopify-section, section');
    return sec && sec.querySelector('form[data-type="add-to-cart-form"]');
  }

  function money(cents) {
    return '$' + Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  /* ¿Tienes bidón retornable?: cambia el producto que se agrega y el precio a la vista. */
  doc.addEventListener('change', function (ev) {
    var radio = ev.target;
    if (!radio.matches || !radio.matches('[data-rz-envase] input[type="radio"]')) return;
    var box = radio.closest('[data-rz-envase]');
    var form = formFor(box);
    var idInput = form && form.querySelector('[name="id"]');
    if (idInput) idInput.value = radio.dataset.id;
    var no = radio.value === 'no';

    box.querySelectorAll('[data-rz-envase-nota]').forEach(function (p) {
      p.hidden = p.dataset.rzEnvaseNota !== radio.value;
    });

    var scope = box.closest('.rz-item') || box.closest('.shopify-section, section');
    if (!scope) return;
    scope.querySelectorAll('[data-rz-tramos], .rz-tramos-corto').forEach(function (t) { t.hidden = no; });

    /* Tarjeta del pedido rápido */
    var now = scope.querySelector('.rz-item__now');
    var was = scope.querySelector('.rz-item__was');
    if (now) now.textContent = radio.dataset.price;
    if (was) { was.textContent = radio.dataset.was; was.hidden = !radio.dataset.was; }

    /* Precio de la ficha (bloque de precio de Olivia) */
    var price = scope.querySelector('.price');
    if (price) {
      price.querySelectorAll('.price-item--sale, .price__regular .price-item--regular').forEach(function (n) {
        n.textContent = radio.dataset.price;
      });
      price.querySelectorAll('.price-item--strikethrough').forEach(function (n) { n.textContent = radio.dataset.was; });
    }
    /* El ahorro que muestra Olivia ("- $800") se recalcula para el producto elegido. */
    scope.querySelectorAll('.price__badge-sale').forEach(function (n) {
      n.textContent = radio.dataset.save ? '- ' + radio.dataset.save : '';
      n.style.display = radio.dataset.save ? '' : 'none';
    });
  });

  /* Comprar ahora: agrega al carrito y va directo al pago, si el pedido llega al mínimo. */
  doc.addEventListener('click', function (ev) {
    var btn = ev.target.closest && ev.target.closest('[data-rz-ahora]');
    if (!btn) return;
    ev.preventDefault();
    var form = formFor(btn);
    if (!form) return;
    var id = form.querySelector('[name="id"]').value;
    var qtyInput = (form.id && doc.querySelector('[name="quantity"][form="' + form.id + '"]')) || form.querySelector('[name="quantity"]');
    var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
    var min = parseInt(btn.dataset.min, 10) || 0;
    var msg = btn.parentNode.querySelector('[data-rz-ahora-msg]');
    var label = btn.textContent;

    function say(text) {
      if (!msg) return;
      msg.textContent = text;
      msg.hidden = !text;
    }

    btn.disabled = true;
    btn.textContent = 'Preparando tu pedido…';
    say('');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] })
    })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        if (cart.total_price < min) {
          say('Tu pedido suma ' + money(cart.total_price) + '. El mínimo para el despacho es de 2 recargas: agrega una más y vuelve a tocar Comprar ahora.');
          btn.disabled = false;
          btn.textContent = label;
          return;
        }
        window.location.href = '/checkout';
      })
      .catch(function (err) {
        say((err && (err.description || err.message)) || 'No pudimos agregar el producto. Intenta de nuevo.');
        btn.disabled = false;
        btn.textContent = label;
      });
  });

  /* Si la suscripción se envió de la forma normal (con recarga), Shopify vuelve con el mensaje de éxito:
     se reemplaza por la caja con el código y el botón para copiarlo. */
  function codigoTrasRecarga(root) {
    root.querySelectorAll('form.newsletter-form').forEach(function (form) {
      if (!form.querySelector('.newsletter-form__message--success')) return;
      mostrarCodigo(form);
      var caja = form.parentNode.querySelector('.rz-bienvenida');
      if (caja) caja.scrollIntoView({ block: 'center' });
    });
  }

  function init(root) {
    reveal(root);
    tagline(root);
    comuna(root);
    codigoTrasRecarga(root);
    /* Si el navegador recuerda "No" al volver atrás, el producto del formulario tiene que coincidir. */
    root.querySelectorAll('[data-rz-envase] input[value="no"]:checked').forEach(function (r) {
      r.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* Suscripción sin recargar la página: se envía el correo por detrás y se muestra al tiro el código
     de bienvenida con un botón para copiarlo. Si Shopify pide verificación (captcha) o algo falla,
     el formulario se envía de la forma normal y la página muestra el código en su mensaje de éxito. */
  var CODIGO_BIENVENIDA = 'BIENVENIDA5';

  function estilosBienvenida() {
    if (doc.getElementById('rz-bienvenida-css')) return;
    var st = doc.createElement('style');
    st.id = 'rz-bienvenida-css';
    st.textContent =
      '.rz-bienvenida{margin-top:12px;padding:16px;border:2px dashed #0b5cff;border-radius:12px;background:#fff;color:#0a0a0a;text-align:left}' +
      '.rz-bienvenida__t{margin:0 0 10px;font-weight:600;font-size:15px;line-height:1.4}' +
      '.rz-bienvenida__code{display:flex;align-items:center;gap:8px;flex-wrap:wrap}' +
      '.rz-bienvenida__code input{flex:1 1 100%;min-width:0;padding:10px 12px;border:1px solid #c9d6f5;border-radius:8px;background:#f3f7ff;font-size:20px;font-weight:700;letter-spacing:.08em;color:#0b5cff;text-align:center}' +
      '.rz-bienvenida__code button{flex:1 1 100%;padding:12px 18px;border:0;border-radius:40px;background:#0b5cff;color:#fff;font-size:15px;font-weight:600;cursor:pointer}' +
      '.rz-bienvenida__code button:active{transform:translateY(1px)}' +
      '.rz-bienvenida__n{margin:10px 0 0;font-size:13px;line-height:1.45;opacity:.8}';
    doc.head.appendChild(st);
  }

  function copiar(texto, input) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(texto);
    return new Promise(function (ok, mal) {
      try {
        input.removeAttribute('readonly');
        input.select();
        input.setSelectionRange(0, 99);
        var hecho = doc.execCommand('copy');
        input.setAttribute('readonly', '');
        hecho ? ok() : mal();
      } catch (e) { mal(e); }
    });
  }

  function mostrarCodigo(form) {
    estilosBienvenida();
    var wrap = form.querySelector('.newsletter-form__field-wrapper');
    if (wrap) wrap.hidden = true;
    /* El tema fuerza display en estos mensajes, así que hidden no basta. */
    form.querySelectorAll('.newsletter-form__message').forEach(function (m) { m.style.display = 'none'; });
    var caja = form.parentNode.querySelector('.rz-bienvenida');
    if (!caja) {
      caja = doc.createElement('div');
      caja.className = 'rz-bienvenida';
      caja.setAttribute('role', 'status');
      caja.innerHTML =
        '<p class="rz-bienvenida__t">¡Listo, ya estás suscrito! Este es tu código de 5%:</p>' +
        '<div class="rz-bienvenida__code"><input type="text" readonly value="' + CODIGO_BIENVENIDA + '" aria-label="Código de descuento">' +
        '<button type="button" data-rz-copiar>Copiar código</button></div>' +
        '<p class="rz-bienvenida__n">Pégalo al pagar tu primera compra desde $5.000. También te lo enviamos por correo.</p>';
      form.parentNode.insertBefore(caja, form.nextSibling);
    }
    caja.querySelector('[data-rz-copiar]').focus({ preventScroll: true });
  }

  doc.addEventListener('click', function (ev) {
    var btn = ev.target.closest && ev.target.closest('[data-rz-copiar]');
    if (!btn) return;
    var input = btn.parentNode.querySelector('input');
    copiar(CODIGO_BIENVENIDA, input).then(function () {
      btn.textContent = 'Copiado ✓';
      setTimeout(function () { btn.textContent = 'Copiar código'; }, 2500);
    }, function () {
      input.select();
      btn.textContent = 'Selecciónalo y cópialo';
    });
  });

  /* Se escucha en window en fase de captura para adelantarse al script de formularios de Shopify, que en
     el primer envío agrega un form_key y reenvía el formulario recargando la página. */
  window.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (ev.defaultPrevented || !form.matches || !form.matches('form.newsletter-form')) return;
    var tags = form.querySelector('[name="contact[tags]"]');
    var email = form.querySelector('[name="contact[email]"]');
    if (!tags || tags.value.indexOf('newsletter') === -1 || !email || !email.value) return;
    ev.preventDefault();
    ev.stopPropagation();
    var btn = form.querySelector('button[type="submit"]');
    if (btn) btn.disabled = true;
    fetch(form.getAttribute('action') || '/contact', {
      method: 'POST',
      body: new FormData(form),
      credentials: 'same-origin',
      headers: { Accept: 'text/html' }
    })
      .then(function (r) {
        if (!r.ok || r.url.indexOf('customer_posted=true') === -1) throw new Error('sin confirmar');
        mostrarCodigo(form);
      })
      .catch(function () {
        if (btn) btn.disabled = false;
        HTMLFormElement.prototype.submit.call(form);
      });
  }, true);

  /* Enlaces a "#suscripcion" (aviso del 5% extra): bajan a la sección de suscripción de la home.
     El id real de la sección cambia con cada tema, por eso se busca por el final. */
  function irASuscripcion() {
    if (window.location.hash !== '#suscripcion') return;
    var sec = doc.querySelector('[id$="__suscripcion"]');
    if (!sec) return;
    sec.scrollIntoView({ block: 'start' });
    var input = sec.querySelector('input[type="email"]');
    if (input) setTimeout(function () { input.focus({ preventScroll: true }); }, 600);
  }
  window.addEventListener('hashchange', irASuscripcion);
  window.addEventListener('load', irASuscripcion);

  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', function () { init(doc); });
  } else {
    init(doc);
  }
  doc.addEventListener('shopify:section:load', function (ev) { init(ev.target); });
})();
